module.exports = __webpack_public_path__ + "img/community-intro.477cb85.png";